<template>
    <div>
        <v-dialog
            :fullscreen="$vuetify.breakpoint.smAndDown"
            v-model="dialog"
            max-height="80vh"
            max-width="80vw"
            persistent
            @keydown.esc="dialog = false"
        >
            <v-card>
                <v-card-title>
                    <h1 class="font-weight-medium headline my-0 py-0">
                        Notificar
                    </h1>
                    <v-spacer></v-spacer>
                    <v-btn
                        flat
                        icon
                        large
                        class="my-0 py-0"
                        @click="
                            dialog = false;
                            minDialog = true;
                        "
                        v-if="tabs != 1"
                    >
                        <v-icon>minimize</v-icon>
                    </v-btn>
                    <v-btn flat icon large class="my-0 py-0" @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="padding: 0">
                    <v-layout
                        column
                        :style="
                            $vuetify.breakpoint.smAndDown
                                ? 'height: 55vh'
                                : 'height: 72vh'
                        "
                    >
                        <v-flex md12 style="overflow: auto">
                            <v-tabs
                                id="tab-wrapper"
                                v-model="tabs"
                                color="cyan"
                                dark
                                slider-color="accent"
                            >
                                <v-tab v-for="n in 4" :key="n" ripple>Item {{ n }}</v-tab>
                                <v-tab-item>
                                    <template>
                                        <v-data-table
                                            :headers="headers"
                                            :items="strategies"
                                            hide-actions
                                            item-key="id"
                                            no-data-text="Nenhuma estratégia"
                                        >
                                            <template
                                                slot="items"
                                                slot-scope="{ item, index }"
                                            >
                                                <tr
                                                    :style="
                                                        item.notificationContacts == 0
                                                            ? 'opacity:0.5;'
                                                            : ''
                                                    "
                                                    :class="
                                                        index % 2 == 0 ? '' : 'tr-shadow'
                                                    "
                                                >
                                                    <td>{{ item.creditor.name }}</td>

                                                    <td style="text-align: right">
                                                        {{ item.id }}
                                                    </td>

                                                    <td
                                                        @click="showStrategy(item)"
                                                        class="text-truncate"
                                                        style="cursor: pointer"
                                                    >
                                                        {{
                                                            item.name.length > 30
                                                                ? item.name.substr(
                                                                      0,
                                                                      30
                                                                  ) + " ..."
                                                                : item.name
                                                        }}
                                                    </td>

                                                    <td
                                                        :style="
                                                            item.public
                                                                ? `color:${
                                                                      strategyPublic[
                                                                          item.public
                                                                      ].color
                                                                  }`
                                                                : ''
                                                        "
                                                    >
                                                        <b>{{
                                                            item.public
                                                                ? strategyPublic[
                                                                      item.public
                                                                  ].name.toUpperCase()
                                                                : ""
                                                        }}</b>
                                                    </td>

                                                    <td
                                                        @click="
                                                            showMessages(item.approach)
                                                        "
                                                        style="cursor: pointer"
                                                        class="text-xs-left py-1"
                                                    >
                                                        <span
                                                            :class="`tag-approach-type small ${item.approach.type}`"
                                                            >{{
                                                                item.approach.type
                                                            }}</span
                                                        >
                                                        {{
                                                            item.approach.name.length > 30
                                                                ? item.approach.name.substr(
                                                                      0,
                                                                      30
                                                                  ) + " ..."
                                                                : item.approach.name
                                                        }}
                                                    </td>

                                                    <td class="text-xs-left">
                                                        <strong
                                                            v-if="
                                                                !item.simulating &&
                                                                !item.failed
                                                            "
                                                        >
                                                            <p
                                                                @click="
                                                                    showStrategy(
                                                                        item,
                                                                        item.query
                                                                    )
                                                                "
                                                                class="my-0 py-0"
                                                            >
                                                                {{
                                                                    item.notificationContacts
                                                                        | numeral("0,0")
                                                                }}
                                                            </p>
                                                        </strong>
                                                    </td>

                                                    <td class="text-xs-left">
                                                        <strong
                                                            v-if="
                                                                !item.simulating &&
                                                                !item.failed
                                                            "
                                                        >
                                                            <p
                                                                @click="
                                                                    showStrategy(
                                                                        item,
                                                                        item.query
                                                                    )
                                                                "
                                                                class="my-0 py-0"
                                                            >
                                                                {{
                                                                    item.notificationCustomers
                                                                        | numeral("0,0")
                                                                }}
                                                            </p>
                                                        </strong>
                                                    </td>

                                                    <td class="text-xs-left">
                                                        <v-progress-circular
                                                            v-if="item.simulating"
                                                            :width="3"
                                                            :size="20"
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                        <p
                                                            class="my-0 py-0"
                                                            v-if="item.failed"
                                                            style="color: red"
                                                        >
                                                            {{ item.simulatelabel }}
                                                        </p>
                                                        <strong
                                                            v-if="
                                                                !item.simulating &&
                                                                !item.failed
                                                            "
                                                        >
                                                            <p class="my-0 py-0">
                                                                <small
                                                                    >R$
                                                                    {{
                                                                        item.cost
                                                                            | numeral(
                                                                                "0,0[.]00"
                                                                            )
                                                                    }}</small
                                                                >
                                                            </p>
                                                        </strong>
                                                    </td>

                                                    <td class="text-xs-center">
                                                        <v-icon
                                                            v-if="item.done"
                                                            color="primary"
                                                            >mdi-check-bold</v-icon
                                                        >
                                                        <v-progress-circular
                                                            v-else-if="item.waiting"
                                                            :width="3"
                                                            :size="20"
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                        <v-btn
                                                            v-else
                                                            flat
                                                            icon
                                                            text
                                                            color="red"
                                                            @click="
                                                                removeStrategy(item.id)
                                                            "
                                                        >
                                                            <v-icon>close</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-slot:footer>
                                                <td class="pt-2">
                                                    <b
                                                        class="pa-0 font-weight-medium"
                                                        style="font-size: 15px"
                                                        >TOTAL</b
                                                    >
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td class="pt-2"></td>
                                                <td class="text-xs-left">
                                                    <p class="pa-0 font-weight-medium">
                                                        {{
                                                            totalNotifications
                                                                | numeral("0,0")
                                                        }}
                                                    </p>
                                                </td>
                                                <td class="text-xs-left">
                                                    <p class="pa-0 font-weight-medium">
                                                        {{
                                                            totalNotificationsCustomers
                                                                | numeral("0,0")
                                                        }}
                                                    </p>
                                                </td>
                                                <td class="text-xs-left">
                                                    <p class="pa-0 font-weight-medium">
                                                        R$
                                                        {{
                                                            totalCost
                                                                | numeral("0,0[.]00")
                                                        }}
                                                    </p>
                                                </td>
                                                <td></td>
                                            </template>
                                        </v-data-table>
                                    </template>
                                    <v-divider></v-divider>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-layout
                                        column
                                        align-center
                                        justify-center
                                        wrap
                                        class="pb-5"
                                    >
                                        <p
                                            :class="`pt-3 pb-5 mt-3 ${
                                                $vuetify.breakpoint.smAndDown
                                                    ? 'headline'
                                                    : 'display-2'
                                            } font-weight-medium text-xs-center`"
                                        >
                                            Serão enviadas
                                            {{ totalNotifications | numeral("0,0") }}
                                            notificações<br />para
                                            {{
                                                totalNotificationsCustomers
                                                    | numeral("0,0")
                                            }}
                                            clientes
                                        </p>
                                        <p
                                            :class="`pt-2 pb-3  ${
                                                $vuetify.breakpoint.smAndDown
                                                    ? 'headline'
                                                    : 'display-2'
                                            } font-weight-light`"
                                        >
                                            Custo aproximado R$
                                            {{ totalCost | numeral("0,0[.]00") }}
                                        </p>
                                        <p class="py-5 display-2" color="primary">
                                            {{ timerlabel }}
                                        </p>
                                        <v-btn
                                            large
                                            color="primary"
                                            @click="cancelFifing()"
                                            >Abortar</v-btn
                                        >
                                    </v-layout>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-layout justify-space-around row align-center wrap>
                                        <v-flex xs12>
                                            <div class="text-xs-left mt-3 ml-3">
                                                <v-btn
                                                    color="green lighten-2"
                                                    style="color: white"
                                                    large
                                                    icon
                                                    @click="tabs = 0"
                                                >
                                                    <v-icon
                                                        >mdi-keyboard-backspace</v-icon
                                                    >
                                                </v-btn>
                                            </div>
                                        </v-flex>
                                        <!--SMS-->
                                        <v-list
                                            three-line
                                            subheader
                                            v-if="tabApproach.type == 'SMS'"
                                        >
                                            <v-list-tile
                                                v-for="(item, index) in tabApproach.data
                                                    .messages"
                                                :key="index"
                                                class="item-content"
                                            >
                                                <v-list-tile-content
                                                    class="text-xs-center"
                                                    >{{ item }}</v-list-tile-content
                                                >
                                            </v-list-tile>
                                        </v-list>
                                        <!--SMS-->
                                        <!--PUSH -->
                                        <v-list
                                            three-line
                                            subheader
                                            v-if="tabApproach.type == 'PUSH'"
                                        >
                                            <v-list-tile
                                                v-for="(item, index) in tabApproach.data"
                                                :key="index"
                                                class="item-content"
                                            >
                                                <v-list-tile-content
                                                    class="text-xs-center"
                                                >
                                                    <p>{{ item.title }}</p>
                                                    <br />
                                                    <p>{{ item.body }}</p>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                        <!--PUSH -->
                                        <!--EMAIL-->
                                        <v-list
                                            three-line
                                            subheader
                                            v-if="tabApproach.type == 'EMAIL'"
                                        >
                                            <v-list-tile
                                                v-for="(item, index) in tabApproach.data
                                                    .emails"
                                                :key="index"
                                                class="item-content"
                                            >
                                                <v-list-tile-content
                                                    class="text-xs-center"
                                                >
                                                    <small>{{ item.subject }}</small>
                                                    <br />
                                                    > {{ item.url }}
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                        <!--EMAIL-->
                                    </v-layout>
                                </v-tab-item>
                                <v-tab-item>
                                    <StrategyOverview :strategy="tabStrategy" :creditor="creditor">
                                        <template v-slot:back>
                                            <v-flex xs12>
                                                <div class="text-xs-left mt-3 ml-3">
                                                    <v-btn
                                                        color="green lighten-2"
                                                        style="color: white"
                                                        large
                                                        icon
                                                        @click="tabs = 0"
                                                    >
                                                        <v-icon
                                                            >mdi-keyboard-backspace</v-icon
                                                        >
                                                    </v-btn>
                                                </div>
                                            </v-flex>
                                        </template>
                                    </StrategyOverview>
                                    <v-container fluid v-if="resultQuery">
                                        <v-layout row justify-center>
                                            <v-btn
                                                @click="copyQuery"
                                                color="secondary"
                                                small
                                            >
                                                Copiar Sql</v-btn
                                            >
                                        </v-layout>
                                        <v-textarea
                                            id="queryToCopy"
                                            rounded
                                            hide-details
                                            readonly
                                            auto-grow
                                            :value="resultQuery"
                                        ></v-textarea>
                                    </v-container>
                                </v-tab-item>
                            </v-tabs>
                        </v-flex>
                        <v-divider v-show="tabs === 0"></v-divider>
                        <v-card-actions v-show="tabs === 0">
                            <v-layout column justify-end>
                                <v-layout justify-end align-center wrap>
                                    <v-flex xs6 md2 class="text-md-right px-3">
                                        <v-switch
                                            v-model="includeBats"
                                            label="Incluir iscas"
                                            class="v-messages-none"
                                            style="padding: 0; margin: 0"
                                        ></v-switch>
                                    </v-flex>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        large
                                        v-if="failed"
                                        color="accent"
                                        @click="init()"
                                        >Simular</v-btn
                                    >
                                    <v-btn
                                        flat
                                        color="accent"
                                        style="border-radius: 5px"
                                        v-if="!failed"
                                        :disabled="disabledNotify || !totalNotifications"
                                        @click="confirmFiring()"
                                        >Notificar</v-btn
                                    >
                                </v-layout>
                            </v-layout>
                        </v-card-actions>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-expand-transition>
            <!-- calc(50% - 100px) -->
            <div v-show="minDialog" class="elevation-5 minDialog" id="minDialog">
                <div style="display: flex; width: 444px; height: 36px; line-height: 36px">
                    <v-progress-circular
                        v-if="inProgress()"
                        :width="3"
                        :size="20"
                        indeterminate
                        color="primary"
                        style="margin: auto 0"
                    ></v-progress-circular>
                    <v-icon v-else color="primary" style="width: 20px"
                        >mdi-check-bold</v-icon
                    >
                    <p style="padding-left: 8px !important">
                        {{ situation() }}:
                        <b style="font-size: 16px">{{ finalized }}</b>
                        /{{ strategies.length }}
                    </p>
                </div>
                <v-btn
                    flat
                    icon
                    class="ma-0"
                    style="float: right"
                    color="indigo"
                    @click="
                        dialog = true;
                        minDialog = false;
                    "
                >
                    <v-icon>open_in_full</v-icon>
                </v-btn>
            </div>
        </v-expand-transition>
    </div>
</template>
<script>
import Cookies from 'js-cookie'
import enviroment from '@/enviroment';
import tasksService from "@/services/tasks";
import { EventBus } from "@/services/event-bus";
import strategyPublic from "@/utils/strategy-public";
import StrategyOverview from "@/components/StrategyOverview";

export default {
    props: {},
    components: {
        StrategyOverview,
    },
    data() {
        return {
            resultQuery: null,
            finalized: 0,
            failed: true,
            includeBats: true,
            disabledNotify: true,
            dialog: false,
            minDialog: false,
            notifications: false,
            trCount: 1,
            useCache: true,
            timerlabel: 10,
            tabs: 0,
            timer: 0,
            finalized: 0,
            countdownInterval: null,
            strategy: {},
            interval: {},
            tabApproach: {},
            tabStrategy: {},
            creditor: null,
            strategyPublic: {},
            strategies: [],
            headers: [
                {
                    text: "Credor",
                    align: "left",
                    sortable: false,
                    value: "creditor",
                    width: "10%",
                },
                {
                    text: "#",
                    tooltip: "Id",
                    align: "right",
                    value: "creditor.id",
                    width: "1%",
                },
                {
                    text: "Estratégia",
                    align: "left",
                    sortable: false,
                    value: "strategy",
                    width: "15%",
                },
                {
                    text: "Público",
                    align: "left",
                    sortable: false,
                    value: "public",
                    width: "6%",
                },
                {
                    text: "Abordagem",
                    value: "approach",
                    align: "left",
                    sortable: false,
                    width: "15%",
                },
                {
                    text: "Notificações",
                    value: "",
                    align: "",
                    sortable: false,
                    width: "5%",
                },
                {
                    text: "Clientes",
                    value: "",
                    align: "",
                    sortable: false,
                    width: "5%",
                },
                {
                    text: "Custo",
                    value: "",
                    align: "",
                    sortable: false,
                    width: "5%",
                },
                {
                    text: "",
                    value: "",
                    align: "left",
                    sortable: false,
                    width: "1%",
                },
            ],
        };
    },
    created() {
        Cookies.set("minDialog", "false", {
            domain: enviroment.cookiesDomain,
            path: '/'
        })
        strategyPublic.strategyPublic.forEach((e, i) => {
            this.strategyPublic[e.value] = strategyPublic.strategyPublic[i];
        });
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    beforeMount() {
        let vm = this;
        clearInterval(this.interval);
        vm.strategies = [];
        EventBus.$on("notify", async (dialog, data, useCache = true) => {
            vm.dialog = dialog;
            vm.useCache = useCache;

            if (!data.length && data.length == undefined) {
                data = [data];
            }
            vm.strategies = JSON.parse(JSON.stringify(data));

            this.tabs = 0;
            await this.init();
        });
    },
    watch: {
        dialog() {
            if (!this.minDialog) {
                clearInterval(this.interval);
                this.interval = {};
                if (!this.dialog) {
                    this.finalized = 0;
                    let tasksIds = this.strategies
                        .filter((obj) => {
                            if (obj.taskId && obj.state !== "SUCCESS") return obj.taskId;
                        })
                        .map((e) => e.taskId);
                    this.strategies = [];
                }
            }
        },
        minDialog() {
            if (this.minDialog){
                Cookies.set("minDialog", "true", {
                    domain: enviroment.cookiesDomain,
                    path: '/'
                })
            }
            else {
                Cookies.set("minDialog", "false", {
                    domain: enviroment.cookiesDomain,
                    path: '/'
                })
            }
        },
    },
    computed: {
        totalNotifications() {
            let totalNotifications = 0;
            if (this.strategies.length > 0) {
                this.strategies.forEach((el) => {
                    if (el.notificationContacts && el.notificationContacts > 0) {
                        totalNotifications += el.notificationContacts;
                    }
                });
                return totalNotifications;
            } else {
                this.disabledNotify = true;
                return 0;
            }
        },
        totalNotificationsCustomers() {
            let total = 0;
            if (this.strategies.length > 0) {
                this.strategies.forEach((el) => {
                    if (el.notificationCustomers && el.notificationCustomers > 0) {
                        total += el.notificationCustomers;
                    }
                });
                return total;
            } else {
                this.disabledNotify = true;
                return 0;
            }
        },
        totalCost() {
            let cost = 0;
            if (this.strategies.length > 0) {
                this.strategies.forEach((el) => {
                    if (el.notificationContacts && el.notificationContacts > 0) {
                        cost += el.cost;
                    }
                });
            }
            return cost;
        },
    },
    methods: {
        async init() {
            this.failed = false;
            this.disabledNotify = true;
            if (this.strategies.length > 0) {
                this.strategies.forEach((el, i) => {
                    el.simulating = true;
                    el.expanded = false;
                    el.failed = false;
                    el.simulatelabel = "Simulando...";
                });
                await this.update();
                if (this.strategies.length > 1) {
                    this.simulateMultiple();
                } else {
                    this.simulateOne();
                }
            }
        },
        cancelFifing() {
            clearInterval(this.countdownInterval);
            this.tabs = 0;
        },
        showMessages(item) {
            this.tabApproach = item;
            this.tabs = 2;
        },
        showStrategy(item, query = null) {
            this.resultQuery = query ? query : null;
            this.tabs = 3;
            this.tabStrategy = item;
            this.creditor = item.creditor.name;
        },
        confirmFiring(item = null) {
            clearInterval(this.countdownInterval);
            this.tabs = 1;
            this.setCountDown();
        },
        setTrStyle(item) {
            this.trCount++;
            return this.trCount % 2 == 0 ? "tr-shadow" : "";
        },
        setCountDown() {
            let vm = this;
            vm.timer = 1;
            vm.timerlabel = 10;
            vm.countdownInterval = setInterval(() => {
                if (vm.timer >= 10) {
                    vm.fireMultiple();
                    clearInterval(vm.countdownInterval);
                    vm.tabs = 0;
                }
                vm.timerlabel = 10 - vm.timer;
                vm.timer++;
            }, 1000);
        },
        async simulateMultiple() {
            let strategyIds = this.strategies.map((e) => e.id);
            let vm = this;
            await tasksService
                .strategiesSimulate(strategyIds, vm.useCache)
                .then(async (res) => {
                    let taskIds = res.strategy_tasks;
                    for (let i = 0; i < vm.strategies.length; i++) {
                        vm.strategies[i].taskId = taskIds[vm.strategies[i].id];
                    }
                    vm.checkSimulation();
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        async simulateOne() {
            await tasksService
                .strategySimulate(this.strategies[0].id, this.useCache)
                .then(async (res) => {
                    this.strategies[0].taskId = res.task_id;
                    setTimeout(() => {
                        this.checkSimulation();
                    }, 2000);
                })
                .catch((err) => {
                    this.$store.commit(
                        "showSnackbar",
                        "Houve um erro ao simular a estratégia"
                    );
                    console.error(err);
                });
        },
        async fireMultiple() {
            let vm = this;
            vm.dialogConfirm = false;
            let strategyIds = vm.strategies
                .filter((obj) => {
                    if (obj.notificationContacts) return obj.id;
                })
                .map((obj) => {
                    return obj.id;
                });
            this.finalized = vm.strategies.length - strategyIds.length;
            vm.strategies.forEach((el, i) => {
                if (el.notificationContacts) el.waiting = true;
            });
            await vm.update();
            if (vm.strategies.length == 1 || strategyIds.length == 1)
                return await vm.fireOne();

            await tasksService
                .strategiesFire(
                    strategyIds,
                    '',
                    '',
                    vm.includeBats
                )
                .then(async (res) => {
                    let taskIds = res.strategy_tasks;
                    for (let i = 0; i < vm.strategies.length; i++) {
                        if (vm.strategies[i].waiting) {
                            vm.strategies[i].taskId = taskIds[vm.strategies[i].id];
                        }
                    }
                    setTimeout(() => {
                        vm.checkSent();
                    }, 2000);
                })
                .catch((err) => {
                    console.error(err);
                });
            },
        async fireOne() {
            let index = 0;
            let vm = this;
            if (vm.strategies.length > 1) {
                vm.strategies.forEach((el, i) => {
                    if (el.waiting) index = i;
                });
            }
            await tasksService
                .strategyFire(
                    vm.strategies[index].id,
                    '',
                    '',
                    vm.includeBats
                )
                .then(async (res) => {
                    vm.strategies[index].taskId = res.task_id;
                    setTimeout(() => {
                        vm.checkSent();
                    }, 2000);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        copyQuery() {
            let input = document.getElementById("queryToCopy");
            input.select();
            document.execCommand("copy");
        },
        async revokeTask(taskId) {
            let res = await tasksService.revoke(taskId);
        },
        async revokeManyTasks(tasksIds) {
            let res = await tasksService.revokeMany(tasksIds);
        },
        async checkSent() {
            this.disabledNotify = true;
            let pedding;
            clearInterval(this.interval);
            this.interval = setInterval(async () => {
                pedding = 0;
                this.strategies.forEach(async (el, i) => {
                    if (el.waiting) {
                        pedding++;
                        if (!el.requesting && pedding < 3) {
                            el.requesting = true;
                            await tasksService
                                .get(el.taskId)
                                .then(async (res) => {
                                    if (
                                        res.state == "SUCCESS" ||
                                        res.state == "PENDING"
                                    ) {
                                        this.finalized++;
                                        el.waiting = false;
                                        el.state = res.state;
                                        el.done = true;
                                    } else if (res.state == "FAILURE") {
                                        this.finalized++;

                                        el.simulating = false;
                                        el.failed = true;
                                        el.waiting = false;
                                        el.state = "FAILURE";
                                        el.simulatelabel = "Disparo falhou";
                                    }
                                })
                                .catch((err) => {
                                    console.error(err);
                                    if (err.response.status == 500) {
                                        el.simulating = false;
                                        el.failed = true;
                                        el.waiting = false;
                                        el.state = "FAILURE";
                                        el.simulatelabel = "Disparo falhou";
                                    }
                                })
                                .finally(() => {
                                    el.requesting = false;
                                });
                        }
                    }
                });
                if (pedding == 0) {
                    clearInterval(this.interval);
                    await this.update();
                } else {
                    pedding = 0;
                }
            }, 3000);
        },
        async checkSimulation() {
            let pedding;
            this.failed = false;
            clearInterval(this.interval);
            this.interval = setInterval(async () => {
                pedding = 0;
                this.strategies.forEach(async (el, i) => {
                    if (el.simulating && !this.failed) {
                        pedding++;
                        if (!el.requesting && pedding < 5) {
                            el.requesting = true;
                            tasksService
                                .get(el.taskId)
                                .then(async (res) => {
                                    if (res.state == "SUCCESS") {
                                        this.finalized++;
                                        el.simulating = false;
                                        el.state = res.state;
                                        el.simulatelabel = "";
                                        el.notificationContacts = res.result.contacts;
                                        el.notificationCustomers = res.result.customers;
                                        el.query = res.result.query;
                                        if (el.approach.type.substr(0, 3) == "SMS")
                                            el.cost =
                                                el.notificationContacts *
                                                el.creditor.default_sms_gateway.cost;
                                        else el.cost = 0;
                                    } else if (res.state == "FAILURE" || this.failed) {
                                        this.finalized++;
                                        el.simulating = false;
                                        el.failed = true;
                                        el.simulatelabel = "Simulação falhou";
                                    }
                                })
                                .catch((err) => {
                                    console.error(err);
                                    if (err.response.status == 500) {
                                        this.finalized++;
                                        el.simulating = false;
                                        el.failed = true;
                                        el.simulatelabel = "Simulação falhou";
                                    }
                                })
                                .finally(() => {
                                    el.requesting = false;
                                });
                        }
                    } else if (this.failed) {
                        el.simulating = false;
                        el.failed = true;
                        el.simulatelabel = "Simulação falhou";
                    }
                });
                if (pedding == 0) {
                    clearInterval(this.interval);
                    await this.update();
                    this.disabledNotify = false;
                } else {
                    pedding = 0;
                }
            }, 3000);
        },
        async updateObjectList(id, list) {
            return list.filter(function (e) {
                return e.id !== id;
            });
        },
        async removeStrategy(id) {
            let strategy = this.strategies.find((e) => e.id === id);
            // this.revokeTask(strategy.taskId);
            this.strategies = await this.updateObjectList(id, this.strategies);
        },
        async update() {
            this.strategies = JSON.parse(JSON.stringify(this.strategies));
        },
        situation() {
            if (!this.strategies.length) return "";
            return this.strategies[0].done || this.strategies[0].waiting
                ? "Disparos"
                : "Simulando";
        },
        inProgress() {
            if (!this.strategies.length) return true;
            if (this.strategies[0].done || this.strategies[0].waiting) {
                let progress = false;
                this.strategies.forEach(async (el, i) => {
                    if (el.waiting) progress = true;
                });
                return progress;
            } else {
                return this.disabledNotify;
            }
        },
    },
};
</script>

<style>
#tab-wrapper .v-tabs__wrapper {
    display: none !important;
}
.shadow-tr {
    background-color: rgba(0, 0, 0, 0.06);
}
p {
    margin: 0;
    padding: 0 !important;
}

td {
    padding: 10px 0;
}

.border {
    border-radius: 5px;
}

.card-content {
    overflow: auto;
    max-height: 600px;
}

.item-content {
    margin: 10px 0px;
    padding: 5px 2px;
    border-color: #d3d3d3;
    border-style: dashed;
    border-width: 2px;
    border-radius: 10px;
}
.minDialog {
    background: white;
    position: fixed;
    display: flex;
    left: 60px;
    bottom: 0;
    width: 200px;
    height: 46px;
    border-radius: 4px 4px 0 0;
    padding: 5px 10px;
}
</style>
